module.exports = __webpack_public_path__ + "media/images/brand/logo-04-99a5580551797511da5a02ac1d5b1976.png";